var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('input',{ref:"doc",staticClass:"btn-green",attrs:{"type":"file"},on:{"change":function($event){return _vm.readFile()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }